module.exports = __webpack_public_path__ + "assets/img/file-icon.434210d5.svg";